import { MUTATION_TYPES } from "./types";

const mutations = {
  [MUTATION_TYPES.ADD_STUDENT_SEARCHED](state, data) {
    let historyData;

    if (Array.isArray(data)) {
      historyData = data;
    } else {
      historyData = JSON.parse(sessionStorage.getItem("student-history"));
      historyData.push(data);
    }

    if (historyData.length > 0) {
      state.searchedStudentHistory = [];
      for (let studenInfoIndex in historyData) {
        let studenInfo = historyData[studenInfoIndex];
        // Verifica si el estudiante existe dentro del historial para borrarlo y
        // agregarlo como el mas reciente en el storage
        let ArrayHistory = [...state.searchedStudentHistory];
        let Exists = false;
        //Centralizada la informacion que se agrega de manera temporal a la busqueda
        let studentInformationDto = {
          studentId: studenInfo.studentId,
          fullName: studenInfo.firstName + " " + studenInfo.lastName,
          impediment:
            studenInfo.MipeStudent != null
              ? studenInfo.impedimentDescription
              : studenInfo.primaryImpediment,
          statusType: studenInfo.statusType
        };

        for (let index in ArrayHistory) {
          if (
            ArrayHistory[index].studentId == studentInformationDto.studentId
          ) {
            state.searchedStudentHistory.splice(Number(index), 1);
            Exists = true;
            break;
          }
        }

        if (
          state.searchedStudentHistory.length >=
            process.env.VUE_APP_DEFAULT_PAGE_SIZE &&
          !Exists
        ) {
          state.searchedStudentHistory.splice(0, 1);
        }
        state.searchedStudentHistory.push(studenInfo);
      }

      sessionStorage.setItem(
        "student-history",
        JSON.stringify(state.searchedStudentHistory)
      );
    }
  },

  [MUTATION_TYPES.SET_ALERTS](state, payload) {
    state.alerts = payload;
  },
  [MUTATION_TYPES.TOGGLE_SEARCH](state, value) {
    if (value == undefined) {
      state.searchOpened = !state.searchOpened;
      state.showFastSearch = !state.showFastSearch;
    } else {
      state.searchOpened = value;
      state.showFastSearch = value;
    }
  },
  [MUTATION_TYPES.SHOW_SELECTED_STUDENT](state, value) {
    state.showSelectedStudent = value;
  },
  [MUTATION_TYPES.SET_NAVIGATION_VIEW_DISPLAY](state, value) {
    state.navigateToViewDisplay = value;
  },
  [MUTATION_TYPES.SELECTED_STUDENT](state, value) {
    state.selectedStudent = value;
    state.studentId = value.studentId;
    //Set in sessionStorage
    sessionStorage.setItem("selected-student", JSON.stringify(value));
  },
  [MUTATION_TYPES.CLEAR_ALERTS](state) {
    state.alerts = [];
  },
  [MUTATION_TYPES.SELECTED_STUDENT_DETAILS](state, value) {
    state.details = value;
    sessionStorage.setItem("selected-student-details", JSON.stringify(value));
  },
  [MUTATION_TYPES.CLEAR_STUDENT](state) {
    state.selectedStudent = null;
    state.details = null;
    state.navigateToViewDisplay = false;
    state.navigateToViewRoute = "";
    state.navigateToViewCard = null;
    state.showSelectedStudent = false;
    sessionStorage.removeItem("selected-student");
    sessionStorage.removeItem("selected-student-details");
    sessionStorage.removeItem("show-selected-student");
  },
  [MUTATION_TYPES.SET_SHOW_STUDENT_SELECTED](state, value) {
    state.showSelectedStudent = value;
    sessionStorage.setItem("show-selected-student", JSON.stringify(value));
  },
  [MUTATION_TYPES.TOGGLE_FAST_SEARCH](state, value) {
    state.showFastSearch = value;
  },
  [MUTATION_TYPES.SET_STUDENT_PRE_REGISTRY](state, reg) {
    state.selectedStudentPreRegistry = {
      regStudentId: reg.regStudentId,
      regStudentPostRegistryId: reg.regStudentPostRegistryId,
      academicYearId: reg.academicYearId,
      statusId: reg.statusId,
      isReadMode: reg.isReadMode,
      isInitialRegistry: reg.isInitialRegistry == "1",
      registrationDate: reg.registrationDate,
      isReadModePostRegistry: reg.isReadModePostRegistry,
      isPostRegistry: reg.isPostRegistry,
      hasInitialEvaluationFlag: reg.hasInitialEvaluationFlag
    };
  },
  [MUTATION_TYPES.SET_STUDENT_PRE_REGISTRY_VALIDATIONS](state, validations) {
    state.studentPreRegistryValidations = validations;
  },
  [MUTATION_TYPES.SET_REGISTER_SAVE_PROPAGATION](state, data) {
    state.isStudentRegistryPropagation = {
      value: data.value,
      validateTab1: data.validateTab1,
      date: data.date
    };
  },
  SetRegStudentId(state, RegId) {
    state.regStudentId = RegId;
    state.selectedStudent.regStudentId = RegId;
  },
  setSelectedStudentStatus(state, status) {
    state.selectedStudent.status = status;
  },
  setStudentId(state, value) {
    state.studentId = value;
  },
  ChangeStatusModal(state, sieForModal = "") {
    state.sieForModal = sieForModal;
    state.ShowModal = !state.ShowModal;
  },
  setPostRegistryState(state, value) {
    state.postRegistryState = value;
  }
};

export default mutations;
